import { render } from "./PrinterSetups.vue?vue&type=template&id=2bbe5ddd&ts=true"
import script from "./PrinterSetups.vue?vue&type=script&lang=ts"
export * from "./PrinterSetups.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__